export default __webpack_public_path__ + "static/media/LOCKED_BLOCK.34d15f34.svg";